/* Sushiya Cart Tweaks 23 Oct (preview):
   1) Remove (X) on applied discount codes in the cart drawer and /cart. Uses the Cart Ajax API
      POST /cart/update.js { discount: "<remaining codes>" } ("" clears all) with bundled section rendering,
      then repaints the drawer / cart sections the same way Dawn does after a quantity change.
   2) Pickup panel (details[data-sy-pickup-fold]) opens when the saved PIN is undeliverable (html[data-ts-pin-no]). */
(function () {
  if (window.syCartTweaks) return; window.syCartTweaks = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function parse(html) { return new DOMParser().parseFromString(html || '', 'text/html'); }
  function targets() {
    var t = [];
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.querySelector('.drawer__inner')) t.push({ section: 'cart-drawer', apply: function (doc) {
      var src = doc.querySelector('.drawer__inner'), dst = drawer.querySelector('.drawer__inner'); if (src && dst) dst.innerHTML = src.innerHTML; } });
    if (document.getElementById('cart-icon-bubble')) t.push({ section: 'cart-icon-bubble', apply: function (doc) {
      var src = doc.querySelector('.shopify-section'); if (src) document.getElementById('cart-icon-bubble').innerHTML = src.innerHTML; } });
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id); if (!el || !el.dataset.id) return;
      t.push({ section: el.dataset.id, apply: function (doc) {
        var cur = document.getElementById(id); var dst = cur && (cur.querySelector('.js-contents') || cur);
        var src = doc.querySelector('.js-contents') || doc.getElementById(id); if (dst && src) dst.innerHTML = src.innerHTML; } });
    });
    return t;
  }
  /* A /discount/CODE link also stores the code in the discount_code cookie, and checkout re-applies it from there.
     Drop the removed code from that cookie too, so it is really gone at checkout. */
  function dropCookieCode(code) {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/); if (!m) return;
    var left = decodeURIComponent(m[1]).split(',').filter(function (c) { return c && c.trim().toUpperCase() !== code.toUpperCase(); });
    var host = location.hostname.replace(/^www\./, '');
    [host, '.' + host].forEach(function (d) { document.cookie = 'discount_code=; Max-Age=0; path=/; domain=' + d; });
    document.cookie = left.length ? 'discount_code=' + encodeURIComponent(left.join(',')) + '; path=/; SameSite=Lax'
                                  : 'discount_code=; Max-Age=0; path=/';
  }
  function removeCode(btn) {
    var code = btn.getAttribute('data-sy-remove-code'); if (!code || btn.disabled) return;
    var list = btn.closest('.sy-discs'); var status = list && list.parentNode.querySelector('.sy-disc__status');
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    var inDrawer = !!btn.closest('cart-drawer');
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var keep = (cart.discount_codes || []).map(function (d) { return d.code; })
        .filter(function (c) { return String(c).toUpperCase() !== code.toUpperCase(); });
      var t = targets();
      dropCookieCode(code);
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: keep.join(','), sections: t.map(function (x) { return x.section; }), sections_url: window.location.pathname })
      }).then(function (r) { if (!r.ok) throw new Error('update ' + r.status); return r.json(); }).then(function (state) {
        var s = state.sections || {};
        t.forEach(function (x) { if (s[x.section]) x.apply(parse(s[x.section])); });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state }); } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('sy:discount-removed', { detail: { code: code, cart: state } }));
        var focusEl = inDrawer ? document.querySelector('cart-drawer #CartDrawer-Checkout, cart-drawer .drawer__close')
                               : document.querySelector('#main-cart-footer #checkout');
        if (focusEl) { try { focusEl.focus({ preventScroll: true }); } catch (e) {} }
        syncFold();
      });
    }).catch(function () {
      btn.disabled = false; btn.removeAttribute('aria-busy');
      if (status && list) { status.textContent = list.getAttribute('data-sy-error') || ''; status.classList.remove('visually-hidden'); }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sy-remove-code]'); if (!b) return;
    e.preventDefault(); removeCode(b);
  });
  /* 2) pickup panel auto-open on undeliverable PIN; a customer's own toggle wins until the next re-render */
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('details[data-sy-pickup-fold] > summary'); if (s) s.parentNode.setAttribute('data-sy-touched', '1');
  }, true);
  function syncFold() {
    var no = document.documentElement.hasAttribute('data-ts-pin-no');
    document.querySelectorAll('details[data-sy-pickup-fold]').forEach(function (d) {
      if (d.hasAttribute('data-sy-touched') || d.getAttribute('data-sy-open') === 'code') return;
      if (no && !d.open) { d.open = true; d.setAttribute('data-sy-auto', 'pin'); }
      else if (!no && d.getAttribute('data-sy-auto') === 'pin') { d.open = false; d.removeAttribute('data-sy-auto'); }
    });
  }
  var queued = false;
  function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; syncFold(); }); }
  function start() {
    syncFold();
    new MutationObserver(queue).observe(document.documentElement, { attributes: true, attributeFilter: ['data-ts-pin-no'] });
    ['cart-drawer', '#MainContent'].forEach(function (sel) { var el = document.querySelector(sel); if (el) new MutationObserver(queue).observe(el, { childList: true, subtree: true }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
